import React, { useEffect, useState } from "react";
import FormTable from "@/components/tables/FormTable";
import TableHead from "@/components/tables/TableHead";
import { fetchForms } from "@/services/form.service";
import { useDataQueries } from "@/utils/hooks/useDataQueries";
import { getListCacheBootstrap, writeListCache } from "@/utils/listPageCache";

type Props = {};

function FormList({}: Props) {
    const [pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem, resetDataQueries] = useDataQueries();
    const listBootstrap = getListCacheBootstrap("forms", { dataLength, sorting, searchItem, filter });

    const [isLoading, setIsLoading] = useState(!listBootstrap.hasCache);
    const [forms, setForms] = useState<any>(listBootstrap.items);
    const [formLeft, setFormLeft] = useState(true);
    const [formHistory, setFormHistory] = useState<any>(listBootstrap.items);
    const [allFetched, setAllFetched] = useState(false);
    const [loadData, setLoadData] = useState(!listBootstrap.hasCache);
    const [totalCount, setTotalCount] = useState(listBootstrap.totalCount);

    const handleFetchAllForms = () => {
        fetchForms(
            pageNo,
            dataLength,
            sorting,
            filter,
            searchItem,
            (response: any) => {
                setLoadData(false);
                setIsLoading(false);
                setTotalCount(response.data.total_count);
                if (response.data?.forms?.length < dataLength) {
                    setFormLeft(false);
                    setAllFetched(true);
                }
                const forms = response.data.forms;
                setForms(forms);
                setFormHistory(forms);
            },
            (error: any) => {
                console.log(error);
                setLoadData(false);
                setIsLoading(false);
            }
        );
    };
    useEffect(() => {
        const { cacheKey, cached } = getListCacheBootstrap("forms", { dataLength, sorting, searchItem, filter });

        setPageNo(1);
        setFormLeft(true);
        setAllFetched(false);
        if (cached) {
            setForms(cached.items);
            setFormHistory(cached.items);
            setTotalCount(cached.totalCount);
            setLoadData(false);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            setLoadData(true);
        }

        fetchForms(
            1,
            dataLength,
            sorting,
            filter,
            searchItem,
            (response: any) => {
                const nextForms = response.data.forms ?? [];
                writeListCache(cacheKey, nextForms, response.data.total_count);
                setLoadData(false);
                setIsLoading(false);
                setTotalCount(response.data.total_count);
                if (nextForms.length < dataLength) {
                    setFormLeft(false);
                    setAllFetched(true);
                }
                setForms(nextForms);
                setFormHistory(nextForms);
            },
            (error: any) => {
                console.log(error);
                setLoadData(false);
                setIsLoading(false);
            }
        );
    }, [dataLength, sorting, searchItem]);

    window.onscroll = function () {
        if (allFetched || isLoading) {
            return;
        }
        if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 1) {
            setPageNo(pageNo + 1);
            setIsLoading(true);
            if (formLeft) {
                fetchForms(
                    pageNo + 1,
                    dataLength,
                    sorting,
                    filter,
                    searchItem,
                    (response: any) => {
                        setIsLoading(false);
                        setTotalCount(response.data.total_count);
                        if (response.data?.forms?.length < dataLength) {
                            setFormLeft(false);
                            setAllFetched(true);
                        }
                        const sorted_forms = response.data.forms;
                        const result = [...forms, ...sorted_forms];
                        setForms(result);
                        setFormHistory(result);
                    },
                    (error: any) => {
                        console.log(error);
                        setIsLoading(false);
                    }
                );
            }
        }
    };

    const search = (searchText: string) => {
        setSearchItem(searchText);
    };

    const resetResponse = () => {
        setFormLeft(true);
        setAllFetched(false);
    };

    const reset = () => {
        resetDataQueries?.();
        resetResponse();
    };
    const handleApplyFilter = () => {
        setPageNo(1);
        resetResponse();
        setLoadData(true);
        setIsLoading(true);
        fetchForms(
            1,
            dataLength,
            sorting,
            filter,
            searchItem,
            (response: any) => {
                setLoadData(false);
                setIsLoading(false);
                setTotalCount(response.data.total_count);
                if (response.data?.forms?.length < dataLength) {
                    setFormLeft(false);
                    setAllFetched(true);
                }
                const forms = response.data.forms;
                setForms(forms);
                setFormHistory(forms);
            },
            (error: any) => {
                console.log(error);
                setLoadData(false);
                setIsLoading(false);
            }
        );
    };

    return (
        <div className="gs-list-page-card">
            <div className="gs-list-page-card-header">
                <TableHead id="envelope-table" handleReset={resetResponse} pageNo={pageNo as number} dataLength={dataLength as number} setFilter={setFilter} filter={filter} setDataLength={setDataLength as (dataLength: number) => void} reset={reset} search={search} title="Forms" currentEnvo={forms.length} totalEnvo={totalCount} handleApplyFilter={handleApplyFilter} />
            </div>
            <FormTable id="template-table" reset={reset} title="Forms" setForms={setForms} search={search} isLoading={isLoading} dataLength={dataLength as number} sorting={sorting} setSorting={setSorting as (sorting: any) => void} searchItem={searchItem as string} allFetched={allFetched} forms={forms} dataLoad={loadData} resetDataQueries={resetDataQueries} setPageNo={setPageNo} loadingData={isLoading} />
        </div>
    );
}

export default FormList;
